import ValidatedGroup from "../validated-group";
/**
 * Allow to validate a radio inputs group
 */
export default class ValidatedRadioGroup extends ValidatedGroup {
    private name: string;

    constructor(props: any, element: HTMLInputElement) {
        super(props, element);
    }

    mounted(): void {
        this.inputsArray = [...this.element.querySelectorAll('input[type=radio]')] as HTMLInputElement[];

        // Take name from 1st radio
        this.name = this.inputsArray[0].name;

        this.errorMessage = document.querySelector('[data-valmsg-for="' + this.name + '"]');
    }

    displayErrors(): void {
        if (this.valid) {
            this.errorMessage.innerHTML = "";
            this.errorMessage.classList.remove("error");
        } else {
            this.errorMessage.innerHTML = this.requiredMessage;
            this.errorMessage.classList.add("error");
        }
    }
}
